import request from '@/axios';
// 查列表
export const getManageList = query => {
  return request({
    url: '/lebo-desk/config/commonTemplate/page',
    method: 'GET',
    params: query
  });
};

// 删除
export const delManage = confIds => {
  return request({
    url: '/lebo-desk/config/commonTemplate/delByIds?ids=' + confIds,
    method: 'GET'
  });
};

// 保存配置管理数据
export const saveManageInfo = payload => {
  return request({
    url: '/lebo-desk/config/commonTemplate/save',
    method: 'POST',
    data: payload
  });
};

// 编辑
export const editManageInfo = payload => {
    return request({
      url: '/lebo-desk/config/commonTemplate/update',
      method: 'POST',
      data: payload
    });
  };
  
